// ================================================================
// アコーディオン機能
// ================================================================

// -----------------------------------------------
// アコーディオン初期化
// -----------------------------------------------
export function initAccordion() {
  // 汎用アコーディオン（drawerなど）
  const accordionButtons = document.querySelectorAll('.js-accordion, .js-accordion-button');
  accordionButtons.forEach(accordionButton => {
    accordionButton.addEventListener('click', (event) => handleAccordionClick(event, accordionButton));
  });

  // FAQアコーディオン
  if (document.querySelector('.js-faq-items')) {
    const faqItems = document.querySelector('.js-faq-items');
    faqItems.querySelectorAll('.svc-faq__question').forEach(function (question) {
      question.addEventListener('click', function () {
        // ボタンの状態を切り替え
        this.querySelector('.svc-faq__btn').classList.toggle('is-open');
    
        // アコーディオンをスライドで開閉（ここだけjQueryを使用）
        jQuery(this).next('.svc-faq__answer').slideToggle(300);
      });
    });
  }
}

// -----------------------------------------------
// アコーディオンクリック処理
// -----------------------------------------------
function handleAccordionClick(event, accordionButton) {
  // クリックされた要素がaタグだったら何もしないで抜ける
  if (event.target.tagName.toLowerCase() === 'a') {
    return true;
  }

  event.preventDefault();
  
  const isOpen = accordionButton.classList.contains('is-open');
  let target = accordionButton.querySelector('.js-accordion-target');
  
  if (!target) {
    target = accordionButton.nextElementSibling;
  }

  if (isOpen) {
    closeAccordion(accordionButton, target);
  } else {
    openAccordion(accordionButton, target);
  }
}

// -----------------------------------------------
// アコーディオンを開く
// -----------------------------------------------
function openAccordion(accordionButton, target) {
  if (typeof gsap !== 'undefined') {
    gsap.timeline()
      .to(target, { height: 'auto' })
      .add(() => { accordionButton.classList.add('is-open'); }, '-=.5');
  } else {
    // CSSアニメーション用の改善
    accordionButton.classList.add('is-open');
    
    // 実際のコンテンツ高さを取得
    target.style.maxHeight = 'none';
    target.style.height = 'auto';
    const height = target.scrollHeight;
    target.style.maxHeight = '0';
    target.style.height = '';
    
    // 次のフレームで実際の高さを設定
    requestAnimationFrame(() => {
      target.style.maxHeight = height + 'px';
    });
  }
}

// -----------------------------------------------
// アコーディオンを閉じる
// -----------------------------------------------
function closeAccordion(accordionButton, target) {
  if (typeof gsap !== 'undefined') {
    gsap.to(target, { height: 0 });
  } else {
    // CSSアニメーション用の改善
    target.style.maxHeight = target.scrollHeight + 'px';
    
    requestAnimationFrame(() => {
      target.style.maxHeight = '0';
    });
  }
  accordionButton.classList.remove('is-open');
}